import { AxiosInstance } from "axios"
import { DateTime } from "luxon"

export type NewsCountParams = Readonly<{
    since?: DateTime
}>

export type NewsCountResponse = Readonly<{
    reportDetails: {
        reportTime: DateTime
        since: string
    }
    reportSummary: {
        numberOfNewsArticles: number
    }
}>

export async function fetchNewsCount(
    { since }: NewsCountParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<NewsCountResponse> {
    const url = `/system/news/count`

    const { data } = await axios.get(url, {
        params: {
            since: since || DateTime.now(),
        },
        signal,
    })

    return data
}
